export default "__VITE_ASSET__CLz5lpJ8__"